import { HostFamilyOlComment } from '../../../lib/types/models/host-family-ol-comment/host-family-ol-comment'
import { HostFamilyOlCommentRequest } from '../../../lib/types/models/host-family-ol-comment/host-family-ol-comment-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateHostFamilyOlComment = async (
  data: UpdateInput<HostFamilyOlCommentRequest> & { hostFamilyId: number }
) => {
  const { id, hostFamilyId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.hostFamilies.updateHostFamilyOlComment.url, { id, hostFamilyId }))
    .patch<HostFamilyOlComment, Partial<HostFamilyOlCommentRequest>>(rest)
}
